// shadcn badge https://ui.shadcn.com/docs/components/badge

import { cva } from "class-variance-authority";
import type { VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "text-ds-label-sm focus-visible:ring-pulse-400 inline-flex items-center rounded-sm p-2 focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:outline-none",
  {
    variants: {
      variant: {
        default: "bg-pulse-700 text-pulse-100",
        secondary: "rounded uppercase",
      },
      size: {
        default: "text-ds-label-sm",
        lg: "text-ds-label-md",
      },
      tone: {
        blue: "",
        purple: "",
        "light-blue": "",
      },
    },
    compoundVariants: [
      {
        variant: "secondary",
        tone: "blue",
        class: "bg-grey-950/8 text-grey-950",
      },
      {
        variant: "secondary",
        tone: "purple",
        class: "bg-purple-500/8 text-purple-500",
      },
      {
        variant: "secondary",
        tone: "light-blue",
        class: "bg-pulse-200 text-grey-950",
      },
    ],
    defaultVariants: {
      size: "default",
      variant: "default",
      tone: "blue",
    },
  }
);

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({
  className,
  variant = "default",
  size = "default",
  tone,
  ...props
}: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant, size, tone }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
